import {Game} from '../Game';
import {PointerMoveAction} from 'src/Action';
import {pointerRenderer} from 'src/Pixi/PointerRenderer';

export class PointerMove {
    public constructor(public game: Game) {
        // Sets instance variables
    }

    public byServer(action: PointerMoveAction): void {
        if (!this.game.controller.pixiIsSetup) return;
        if (this.game.index === action.owner) return;
        pointerRenderer.createOrUpdatePointer(action);
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/PointerMove.ts